__turbopack_context__.v({
  "buttonContainer": "vacancyList-module-scss-module__jEDEba__buttonContainer",
  "noRowGap": "vacancyList-module-scss-module__jEDEba__noRowGap",
  "vacancyList": "vacancyList-module-scss-module__jEDEba__vacancyList",
});
